import { z } from 'zod';

import { type ValidationMessageSet } from '../../form-validations';
import { getCaptchaTokenSchema } from '../../schemas/captcha-token-schema';
import { getEmailSchema } from '../../schemas/email-schema';
import {
  type NameValidationMessages,
  getNameSchema,
} from '../../schemas/name-schema';
import { getPhoneSchema } from '../../schemas/phone-schema';

type Messages = {
  campusRequiredMessage: string;
  courseRequiredMessage: string;
  emailValidationMessages: ValidationMessageSet;
  errorMessage: string;
  firstNameValidationMessages: NameValidationMessages;
  lastNameValidationMessages: NameValidationMessages;
  phoneInvalidMessage: string;
  phoneRequiredMessage: string;
  step4RequiredMessage: string;
};

// Validation for client form only
export const getFullApplySchema = (messages: Messages) =>
  z
    .object({
      phone: getPhoneSchema(messages),
      selection: z.object({
        campus: z.string().min(1, messages.campusRequiredMessage),
        format: z.string().min(1, messages.step4RequiredMessage),
        track: z.string().min(1, messages.courseRequiredMessage),
      }),
    })
    .merge(getCaptchaTokenSchema({ requiredMessage: messages.errorMessage }))
    .merge(getEmailSchema(messages.emailValidationMessages))
    .merge(
      getNameSchema(
        messages.firstNameValidationMessages,
        messages.lastNameValidationMessages
      )
    )
    .required();
